import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { getKycDetailsSuccess, getKycDetailsFailure } from "../../Action/kyc/getKycDetailsAction";
import { GET_KYC_DETAILS } from "../../Action/actionTypes";
import { notifyPromise } from "../../../Utils/Helper";

function* kycDetailsRequest(action) {
  try {
    const { id } = action?.payload;
    const { data } = yield API.get(`/kyc-details?id=${id}`);

    if (action?.payload?.callback) {
      yield call(action.payload.callback, data);
    }
    if (data?.meta?.code === 200) {
      yield put(getKycDetailsSuccess(data?.data));
    } else {
      yield put(getKycDetailsFailure());
    }
  } catch (error) {
    yield put(getKycDetailsFailure());
  }
}

export function* watchKycDetailsAPI() {
  yield takeEvery(GET_KYC_DETAILS, kycDetailsRequest);
}

export default function* rootSaga() {
  yield all([watchKycDetailsAPI()]);
}
